import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sport", "metric", "input", "status", "startedAt", "completion"]

  connect() {
    this.sync()
  }

  sync() {
    const option = this.sportTarget.selectedOptions[0]
    const visibleMetrics = new Set()
    const futureWorkout = this.futureWorkout()

    if (this.enabled(option, "tracksDuration")) visibleMetrics.add("duration")
    if (this.enabled(option, "tracksDistance")) visibleMetrics.add("distance")
    if (this.enabled(option, "tracksEnergyBurned")) visibleMetrics.add("energy")
    if (this.enabled(option, "tracksSteps")) visibleMetrics.add("steps")

    this.metricTargets.forEach((metric) => {
      const visible = visibleMetrics.has(metric.dataset.metric)
      metric.classList.toggle("d-none", !visible)
      this.inputsFor(metric.dataset.metric).forEach((input) => {
        input.disabled = !visible
      })
    })

    if (this.hasStatusTarget) {
      this.statusTarget.querySelectorAll("option").forEach((option) => {
        option.disabled = futureWorkout && option.value === "DONE"
      })

      if (futureWorkout) this.statusTarget.value = "SCHEDULED"
      this.statusTarget.disabled = futureWorkout
    }

    this.completionTargets.forEach((container) => {
      const metric = container.dataset.metric
      const hidden = futureWorkout || (metric && !visibleMetrics.has(metric))

      container.classList.toggle("d-none", hidden)
      container.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = hidden || input.closest("[data-athlete-workout-form-target~='metric']")?.classList.contains("d-none")
      })
    })
  }

  enabled(option, key) {
    return option?.dataset?.[key] === "true"
  }

  futureWorkout() {
    if (!this.hasStartedAtTarget || this.startedAtTarget.value === "") return false

    const selectedDate = new Date(this.startedAtTarget.value)
    if (Number.isNaN(selectedDate.getTime())) return false

    const today = new Date()
    selectedDate.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0)

    return selectedDate > today
  }

  inputsFor(metric) {
    return this.inputTargets.filter((input) => input.dataset.metric === metric)
  }
}
